import { CENTRIFUGO_URL } from "@shared/env";
import { SeatingMapItemType } from "@shared/constants/common";

export const REALTIME_SEATING_CONFIG = {
  CENTRIFUGO_URL: CENTRIFUGO_URL || "ws://localhost:8100/connection/websocket",
  CHANNEL_PREFIX_EVENT: "seating:event_",
  CHANNEL_PREFIX_MEMBERSHIP_GROUP: "seating:membership_group_",
  RECONNECT_DELAY_MS: 2000,
  MAX_RECONNECT_DELAY_MS: 30000,
  FEATURE_FLAG: "enable_realtime_seating_updates",
} as const;

export type RealtimeSeatingConfig = typeof REALTIME_SEATING_CONFIG;

export function getSeatingChannel(
  id: number,
  mapItemType: SeatingMapItemType
): string {
  if (mapItemType === SeatingMapItemType.MEMBERSHIP) {
    return `${REALTIME_SEATING_CONFIG.CHANNEL_PREFIX_MEMBERSHIP_GROUP}${id}`;
  }
  return `${REALTIME_SEATING_CONFIG.CHANNEL_PREFIX_EVENT}${id}`;
}
